import { render, staticRenderFns } from "./SolicitudesVehiculosForm.vue?vue&type=template&id=89a85aae"
import script from "./SolicitudesVehiculosForm.vue?vue&type=script&lang=js"
export * from "./SolicitudesVehiculosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports